import React from 'react';
import "../general/General.css";
import PropTypes from 'prop-types';
import { QRCode } from "react-qr-code"; // Using react-qr-code
import { SiInstagram, SiFacebook, SiAndroid, SiApple, SiYoutube, SiWhatsapp } from "react-icons/si";

const qrItems = [
    {
        name: "Android App",
        url: "https://play.google.com/store/apps/details?id=com.sriponnachiammantemples.test&pcampaignid=web_share",
        icon: <SiAndroid size={24} color="#3DDC84" />,
        color: "#3DDC84"
    },
    {
        name: "iOS Web App",
        url: "http://sriponnachiammantemples.in/register",
        icon: <SiApple size={24} color="#000000" />,
         color: "#000000"
    },
    {
        name: "WhatsApp",
        url: "https://whatsapp.com/channel/0029Vamg0f21dAvzNUTrPf2d",
        icon: <SiWhatsapp size={24} color="#25D366" />,
        color: "#25D366"
    },
    {
        name: "Instagram",
        url: "https://www.instagram.com/sriponnachiammantemples",
        icon: <SiInstagram size={24} color="#E1306C" />,
        color: "#E1306C"
    },
    {
        name: "Facebook",
        url: "https://www.facebook.com/profile.php?id=61578804112994",
        icon: <SiFacebook size={24} color="#1877F2" />,
        color: "#1877F2"
    },
    {
        name: "YouTube",
        url: "https://www.youtube.com/@SriPonnachiAmmanTemples",
        icon: <SiYoutube size={24} color="#FF0000" />,
        color: "#FF0000"
    }

];


const SocialMedia = ({ windowWidth }) => {
    return (
        <div className="general_parent">
            <div className="general_container">
                <div className="general_body">
                    <h3>சமூக ஊடகங்கள்</h3>
                    <br />

                    <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem" }}>
                        {qrItems.map(({ name, url, icon, color }) => (
                            <div
                                key={name}
                                style={{
                                    border: "1px solid #444",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                    width: "120px",
                                    textAlign: "center",
                                  
                                    color: "#fff"

                                }}
                            >
                                <div style={{ marginBottom: "10px" }}>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            fontSize: "0.95em",
                                            fontWeight: "500",
                                            color: color
                                        }}
                                    >
                                        {icon}
                                        <span>{name}</span>
                                    </a>
                                </div>
                                
                                <QRCode
                                    value={url}
                                    size={150}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                />
                            </div>
                        ))}
                        <div style={{ marginTop: "2rem" }}>
                            வலைத்தளம்/செயலி(App) தொடர்பான கேள்விகள்/பிரச்சினைகளுக்கு,{" "}
                            <a
                                href="mailto:sriponnachiammantemples@gmail.com?subject=Enquiry&body=I%20would%20like%20to%20inquire..."
                            >
                                sriponnachiammantemples@gmail.com
                            </a>{" "}
                            மின்னஞ்சல் முகவரியைத் தொடர்பு கொள்ளவும்.
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};
// PropTypes validation for windowWidth
Location.propTypes = {
    windowWidth: PropTypes.number.isRequired,  // Ensure windowWidth is a number and required
};

export default SocialMedia;
